export { default as StrategyManagerLayout } from './StrategyManagerLayout';
